import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Calendar, MapPin, Heart, Users } from 'lucide-react';
import { format } from 'date-fns';
import AlertModal from './AlertModal';

export default function EventCard({ event }) {
    const { user, isFavorite, toggleFavorite } = useAuth();
    const favorite = isFavorite(event.id);
    const [showAlert, setShowAlert] = useState(false);

    const handleFavorite = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!user) {
            setShowAlert(true);
            return;
        }
        await toggleFavorite(event.id);
    };

    const formatPrice = (price) => {
        if (!price || price === 0) return 'Free';
        return `$${price}`;
    };

    return (
        <>
            <Link to={`/events/${event.id}`} className="event-card">
                <div className="event-card-image">
                    <img
                        src={event.image_url || 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800'}
                        alt={event.title}
                        onError={(e) => { e.target.onerror = null; e.target.src = 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800'; }}
                    />
                    <span className="event-card-category">{event.category}</span>
                    {/* Favorite button hidden for now
                    <button
                        className={`event-card-favorite ${favorite ? 'active' : ''}`}
                        onClick={handleFavorite}
                    >
                        <Heart size={18} fill={favorite ? 'currentColor' : 'none'} />
                    </button>
                    */}
                </div>

                <div className="event-card-content">
                    <h3 className="event-card-title">{event.title}</h3>

                    <div className="event-card-meta">
                        <div className="event-card-meta-item">
                            <Calendar size={16} />
                            {format(new Date(event.date), 'EEE, MMM d • h:mm a')}
                        </div>
                        <div className="event-card-meta-item">
                            <MapPin size={16} />
                            {event.location}
                        </div>
                        {event.capacity && (
                            <div className="event-card-meta-item">
                                <Users size={16} />
                                {event.capacity} spots
                            </div>
                        )}
                        {event.external_booking_url && (
                            <div className="event-card-meta-item" style={{ color: 'var(--primary)', fontWeight: 600 }}>
                                🎫 Tickets Available
                            </div>
                        )}
                    </div>

                    {event.tags && event.tags.length > 0 && (
                        <div className="event-card-tags">
                            {event.tags.slice(0, 3).map((tag, i) => (
                                <span key={i} className="tag">{tag}</span>
                            ))}
                        </div>
                    )}

                    <div className="event-card-footer">
                        <span className={`event-card-price ${!event.price ? 'free' : ''}`}>
                            {formatPrice(event.price)}
                        </span>
                        <button className="btn btn-secondary" style={{ padding: '8px 16px', fontSize: '13px' }}>
                            View Details
                        </button>
                    </div>
                </div>
            </Link>

            <AlertModal
                isOpen={showAlert}
                onClose={() => setShowAlert(false)}
                title="Login Required"
                message="Please login to save favorites"
                type="info"
            />
        </>
    );
}
